<div class="heading" (mousedown)="dragStart( $event )" (mouseup)="dragEnd()" (mousemove)="dragMove( $event )">
  <svg-icon src="/assets/svg/sparkles.svg" />
  @if ($content().Title) {
  <p>{{ $content().Title }}</p>
  }
</div>
<div class="body-wrapper">
  <div class="body" [innerHTML]="$content().Body"></div>
</div>
<button type="button" class="naked" (click)="clearAppOrientation()"><svg-icon src="/assets/svg/x--small.svg" /></button>
